import React from 'react'
import { connect } from "react-redux"
import Axios from '../../axios/index'
import { MAIN_SELECTED, VIDEO_SELECTED, STUDY_SELECTED, PERSON_SELECTED } from '../../config/footer'
import { SearchBar, Flex, List, Toast } from 'antd-mobile';
import { HashRouter, Route, Switch, Redirect, NavLink } from 'react-router-dom'
import './index.less'
import { hiden_wechat_menu } from "../../utils/index"
class Address extends React.Component {
        state = {
                goto_withdraw_list: false,
                old_data: {},
    
                address_nickname: '',
                address_phone: '',
                address_detail: ''
        }
        apply_withdraw() {
                console.log("申请提现")
        }
        componentDidMount() {
                let that = this;
                Axios.ajax({
                        url: '/get_address_info.php',
                        data: {
                                token: this.props.token
                        }
                }).
                        then((res) => {
                                let userinfo=res.data.userinfo;
                                that.setState({
                                        old_data:userinfo,

                                        address_nickname: userinfo.address_nickname,
                                        address_phone: userinfo.address_phone,
                                        address_detail: userinfo.address_detail
                                })
                        })
        }
        // 监听名称变化
        change_input(e, type) {
                let value = e.target.value;
                let that = this;
                switch (type) {
                        case 'address_nickname':
                                that.setState({
                                        address_nickname: value
                                })
                                break;
                        case 'address_phone':
                                that.setState({
                                        address_phone: value
                                })
                                break;
                        case 'address_detail':
                                that.setState({
                                        address_detail: value
                                })
                                break;


                }

        }
        // 提交提现申请
        submit_withdraw() {
                if (this.state.address_nickname == '' || this.state.address_phone == '' || this.state.address_detail == '') {
                        Toast.info('信息不能为空', 1);
                        return false;
                }
        
                let data = {};
                let that = this;
                let old_data=that.state.old_data;
                data.token = this.props.token;
                data.address_nickname = this.state.address_nickname;
                data.address_phone = this.state.address_phone;
                data.address_detail = this.state.address_detail;
             
                data.isShowLoading = false;
                // 未修改直接返回
                if(data.address_nickname==old_data.address_nickname&&data.address_phone==old_data.address_phone&&data.address_detail==old_data.address_detail){
                        that.setState({
                                goto_withdraw_list: true
                        })
                        return false;
                }
                Axios.ajax({
                        url: '/update_address_info.php',
                        data: data
                }).
                        then((res) => {

                                Toast.info('保存成功', 1);
                                that.setState({
                                        goto_withdraw_list: true
                                })
                        })
        }
        render() {
                if (this.props.shopinfo) { hiden_wechat_menu(this.props.shopinfo); }
                if (this.state.goto_withdraw_list == true) {
                        return (
                                <Redirect to="/person" />
                        );
                }

                return (
                        <div  >

                                <div className="input-row">
                                        <text className="input-label">收货人姓名</text>
                                        <input className="input-value" value={this.state.address_nickname} placeholder="请输入详细收货人姓名" onChange={(e) => this.change_input(e, "address_nickname")} />
                                </div>
                                <div className="input-row">
                                        <text className="input-label">收货手机号</text>
                                        <input className="input-value" value={this.state.address_phone} onChange={(e) => this.change_input(e, "address_phone")} placeholder="请输入详细收货手机号" />
                                </div>
                                <div className="input-row">
                                        <text className="input-label">收货地址</text>
                                        <input className="input-value" value={this.state.address_detail} onChange={(e) => this.change_input(e, "address_detail")} placeholder="请输入详细收货地址" />
                                </div>
                                <div className="hint-row">
                                        * 请填写有效收货地址，虚假数据将会影响物品收货!
                                </div>

                                <div className="withdraw-button" onClick={this.submit_withdraw.bind(this)}>保存</div>
                        </div >







                );
        }
}
const mapStateToProps = state => {

        return {
                token: state.token, shopinfo: state.shopinfo
        }
};

export default connect(mapStateToProps)(Address)